/* eslint-disable no-console */
/* eslint-disable array-callback-return */
import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  retrieveApplicantInfoSuccess,
  getProspectInfoSuccess,
  getProspectInfoFail,
  RETRIEVE_APPLICANT_INFO,
  GET_PROSPECT_INFO_REQUEST
} from "../actions/retrieveApplicantInfo";
import { setConfig, loadMetaData, updateProspect } from "../actions/appConfig";
import { search as searchApi, prospect as prospectApi } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import { getAuthorizationHeader, getSignatoryModel } from "../selectors/appConfig";
import { updateStakeholdersIds } from "../actions/stakeholders";
import { PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID } from "../../containers/CompanyStakeholders/constants";
import { COMPANY_STAKEHOLDER_ID } from "../../containers/PostEligibilityCompanyStakeholders/constants";

import {
  VIEW_IDS,
  PRE_ELIGIBILITY_COMPANY_SIGNATORY_ID,
  PRE_ELIGIBILITY_FINAL_QUESTIONS_COMPANY_ID
} from "../../constants";
import { PRE_ELIGIBILITY_COMPANY_INFO_PAGE_ID } from "../../containers/CompanyInfo/constants";
import { COMPANY_INFO_PAGE_ID } from "../../containers/PostEligibilityCompanyInfo/constants";

import {
  FINAL_QUESTIONS__SALES_ASSIST_COMPANY_ID,
  FINAL_QUESTIONS__SALES_ASSIST_SIGNATORY_ID
} from "../../containers/FinalQuestions/components/CompanySummarySalesAssistCard/constants";
import { COMPANY_INFO_SALES_ASSIST_PAGE_ID } from "../../containers/SalesAssistViews/CompanyInfo/constants";
import { COMPANY_STAKEHOLDER_Sales_Assist_ID } from "../../containers/CompanyStakeholders/SalesAssist/constants";
import {
  POST_ELIGIBILITY_UPLOAD_PAGE_ID,
  POST_ELIGIBILITY_RO_UPLOAD_PAGE_ID
} from "../../containers/PostEligibilityUploadDocuments/constants";

const SELECT_SERVICES_PAGE_ID = "selectServices";

export function* retrieveApplicantInfoSaga({ payload }) {
  try {
    const headers = yield select(getAuthorizationHeader);
    const inputParam = {
      applicantName: payload.fullName || "",
      countryCode: payload.countryCode || "",
      mobileNo: payload.mobileNo || "",
      leadNumber: payload.leadNumber || "",
      tradeLicenseNo: payload.tradeLicenseNo || "",
      email: payload.email || "",
      eidNumber: ""
    };

    const response = yield call(searchApi.searchApplication, inputParam, headers);
    yield put(retrieveApplicantInfoSuccess(response.data));
  } catch (error) {
    log(error);
  }
}

export function* getProspectIdInfo({ payload }) {
  try {
    const headers = yield select(getAuthorizationHeader);
    const response = yield call(prospectApi.get, payload.prospectId, headers);
    const config = { prospect: response.data };
    const freeFieldsInfo = config.prospect.freeFieldsInfo;
    const newStakeholder = yield select(getSignatoryModel);
    if (
      !config.prospect.signatoryInfo.length &&
      config.prospect.applicationInfo.viewId.includes(VIEW_IDS.StakeholdersInfo)
    ) {
      config.prospect.signatoryInfo = [newStakeholder];
    }
    yield put(setConfig(config));

    if (freeFieldsInfo) {
      yield put(loadMetaData(freeFieldsInfo));
      if (freeFieldsInfo.freeField5) {
        try {
          const { completedSteps = [] } = JSON.parse(freeFieldsInfo.freeField5);

          let stakeholderStep = 0;
          let stakeholderStepPE = 0;
          let stakeholderStepRo = 0;
          let signatoryStep = 0;

          let newSteps = [];

          completedSteps.map(step => {
            step.flowId.startsWith(PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID) &&
              (stakeholderStep = stakeholderStep + 1);
            step.flowId.startsWith(COMPANY_STAKEHOLDER_ID) &&
              (stakeholderStepPE = stakeholderStepPE + 1);
            step.flowId.startsWith(COMPANY_STAKEHOLDER_Sales_Assist_ID) &&
              (stakeholderStepRo = stakeholderStepRo + 1);

            step.flowId.startsWith(PRE_ELIGIBILITY_COMPANY_SIGNATORY_ID) &&
              (signatoryStep = signatoryStep + 1);

            step.flowId === PRE_ELIGIBILITY_COMPANY_INFO_PAGE_ID && newSteps.push(step);

            step.flowId.includes(PRE_ELIGIBILITY_FINAL_QUESTIONS_COMPANY_ID) && newSteps.push(step);

            step.flowId.includes(SELECT_SERVICES_PAGE_ID) && newSteps.push(step);

            step.flowId === COMPANY_INFO_PAGE_ID && newSteps.push(step);

            step.flowId.includes(FINAL_QUESTIONS__SALES_ASSIST_COMPANY_ID) && newSteps.push(step);
            step.flowId === COMPANY_INFO_SALES_ASSIST_PAGE_ID && newSteps.push(step);
            step.flowId.includes(FINAL_QUESTIONS__SALES_ASSIST_SIGNATORY_ID) && newSteps.push(step);

            step.flowId.includes(POST_ELIGIBILITY_UPLOAD_PAGE_ID) && newSteps.push(step);

            step.flowId.includes(POST_ELIGIBILITY_RO_UPLOAD_PAGE_ID) && newSteps.push(step);

            if (stakeholderStep < config.prospect.signatoryInfo.length * 6 + 1) {
              step.flowId.startsWith(PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID) && newSteps.push(step);
            }
            if (stakeholderStepPE < config.prospect.signatoryInfo.length * 6 + 1) {
              step.flowId.startsWith(COMPANY_STAKEHOLDER_ID) && newSteps.push(step);
            }
            if (
              step.flowId.startsWith(COMPANY_STAKEHOLDER_Sales_Assist_ID) &&
              step.flowId !== `${COMPANY_STAKEHOLDER_Sales_Assist_ID}undefined`
            ) {
              newSteps.push(step);
            }

            if (signatoryStep < config.prospect.signatoryInfo.length * 4 + 1) {
              step.flowId.startsWith(PRE_ELIGIBILITY_COMPANY_SIGNATORY_ID) && newSteps.push(step);
            }
          });

          freeFieldsInfo.freeField5 = JSON.stringify({ completedSteps: newSteps });

          yield put(loadMetaData(freeFieldsInfo));

          const stakeholdersIds = [
            ...newSteps.reduce((acc, { flowId }) => {
              if (flowId.startsWith(PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID)) {
                acc.add(flowId.split(PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID)[1]);
              } else if (flowId.startsWith(COMPANY_STAKEHOLDER_ID)) {
                acc.add(flowId.split(COMPANY_STAKEHOLDER_ID)[1]);
              }
              return acc;
            }, new Set())
          ];
          yield put(updateStakeholdersIds(stakeholdersIds));
        } catch (error) {
          log(error);
        }
      }
      if (freeFieldsInfo.freeField4 === "" && config?.prospect?.signatoryInfo?.length > 0) {
        const signatoryIds = config.prospect.signatoryInfo.map(({ signatoryId }) => signatoryId);
        yield put(
          updateProspect({
            "prospect.freeFieldsInfo.freeField4": JSON.stringify(signatoryIds)
          })
        );
      }
    }

    yield put(getProspectInfoSuccess(config.prospect));
  } catch (error) {
    log(error);
    yield put(getProspectInfoFail());
  }
}

export default function* retrieveApplicantSaga() {
  yield all([
    takeLatest(RETRIEVE_APPLICANT_INFO, retrieveApplicantInfoSaga),
    takeLatest(GET_PROSPECT_INFO_REQUEST, getProspectIdInfo)
  ]);
}
